import cropMarkApplicationReducer from "./markApplicationReducer";

const cropMarkApplicationReducers = {
    cropMarkApplication: cropMarkApplicationReducer
}

export default cropMarkApplicationReducers;